import React from 'react';
import { useField } from 'formik';

import type { Props as SelectProps } from '@zimpel/common/components/Select';
import ErrorHint from '@zimpel/common/components/ErrorHint';
import Select from '@zimpel/common/components/Select';

type Props = { name: string } & Omit<SelectProps, 'name' | '$hasError'>;

const FormikSelect: React.FC<Props> = ({ name, ...props }) => {
  const [field, meta] = useField(name);
  return (
    <>
      <Select {...field} {...props} $hasError={!!meta.error} />
      {meta.error && <ErrorHint>{meta.error}</ErrorHint>}
    </>
  );
};

export default FormikSelect;
